'use es6';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { usePageTitle } from '../hooks/usePageTitle';
import Chapter from 'academy-shared-js/records/Chapter';
import Exam from 'academy-shared-js/records/Exam';
import ExamScreen from '../features/exams/components/Exam';
import Quiz from 'academy-shared-js/records/Quiz';
import { Quiz as QuizContainer } from '../features/quiz';
import PracticalExercise from 'academy-shared-js/records/PracticalExercise';
import Video from 'academy-shared-js/records/Video';
import Link from 'academy-shared-js/records/Link';
import ACMissingContentError from 'academy-common-lib/components/error/ACMissingContentError';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import LinkContentContainer from './LinkContentContainer';
import ChapterContainer from './Chapter/ChapterContainer';
import { PracticalExercise as PracticalExerciseContainer } from '../features/practicalExercise/components/PracticalExercise';
import { getTracksAreRequesting, getTrackByIdIsLoading } from '../selectors/trackSelectors';
import { VideoPlayerWithControls } from '../features/video';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingPE = () => /*#__PURE__*/_jsx(LoadingSpinner, {
  grow: true,
  minHeight: 400
});
const StoredContentContainer = ({
  contentId,
  content,
  isParentGraded,
  isRequesting,
  lessonId,
  lessonName,
  trackId,
  trackName,
  onFinish,
  language,
  isPubliclyVisible
}) => {
  const contentName = content === null || content === void 0 ? void 0 : content.get('name');
  usePageTitle({
    i18nKey: 'learningCenter.dynamicPageTitles.lessonContent',
    options: {
      contentName
    },
    skip: !contentName
  });
  let ChildComponent = () => null;
  let notFoundError = false;
  if (content instanceof Quiz) {
    ChildComponent = QuizContainer;
  } else if (content instanceof Video) {
    ChildComponent = VideoPlayerWithControls;
  } else if (content instanceof PracticalExercise) {
    ChildComponent = PracticalExerciseContainer;
  } else if (content instanceof Link) {
    ChildComponent = LinkContentContainer;
  } else if (content instanceof Exam) {
    ChildComponent = ExamScreen;
  } else if (content instanceof Chapter) {
    ChildComponent = ChapterContainer;
  } else if (!content) {
    notFoundError = true;
  }
  if (notFoundError) {
    if (isRequesting) {
      return /*#__PURE__*/_jsx(LoadingPE, {});
    }
    return /*#__PURE__*/_jsx(ACMissingContentError, {});
  }
  return /*#__PURE__*/_jsx("div", {
    "data-contentid": contentId // used for testing
    ,
    "data-test-content-requesting": isRequesting,
    "data-test-id": "stored-content-container",
    children: /*#__PURE__*/_jsx(ChildComponent, {
      contentId: contentId,
      isParentGraded: isParentGraded,
      isPubliclyVisible: isPubliclyVisible,
      language: language,
      lessonId: lessonId,
      lessonName: lessonName,
      onFinish: onFinish,
      trackId: Number(trackId),
      trackName: trackName
    })
  });
};
StoredContentContainer.propTypes = {
  content: PropTypes.object.isRequired,
  contentId: PropTypes.string.isRequired,
  isParentGraded: PropTypes.bool,
  isPubliclyVisible: PropTypes.bool,
  isRequesting: PropTypes.bool,
  language: PropTypes.string.isRequired,
  lessonId: PropTypes.string,
  lessonName: PropTypes.string,
  onFinish: PropTypes.func,
  trackId: PropTypes.string,
  trackName: PropTypes.string
};
function mapStateToProps(state, ownProps) {
  const {
    contentId
  } = ownProps;
  const {
    contentById
  } = state;
  const content = contentById.get(contentId);
  let isRequesting = ownProps.isRequesting;
  if (!Object.keys(ownProps).includes('isRequesting')) {
    isRequesting = getTracksAreRequesting(state) || getTrackByIdIsLoading(state);
  }
  return {
    content,
    isRequesting
  };
}
export default connect(mapStateToProps)(StoredContentContainer);